import React, { useEffect, useState } from "react";
import { Tabs, Tab, makeStyles } from "@material-ui/core";


const useStyles = makeStyles({
  selectedTab: {
    fontWeight: "bold",
    color:'black',
    fontSize:'15px' 
  },
});

const FormTabs = ({ formSettings, onSourceFormIdChange,activeTab }) => {
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = useState(0);
  useEffect(()=>{
    const activeTableIndex = formSettings?.findIndex(setting => setting.sourceFormId === activeTab);
    setSelectedTab(activeTableIndex)
  },[])
  if (!formSettings || formSettings.length === 0) {
    return null; 
  }
  
  const handleChange=(event:any,newValue:any)=>{
    setSelectedTab(newValue)
    const sourceFormId=formSettings[newValue]['sourceFormId']
    if (onSourceFormIdChange) {
      onSourceFormIdChange(sourceFormId);
    }
  }

  return (
    <div >
      <Tabs
        value={selectedTab}
        onChange={handleChange}
        indicatorColor="primary"
        variant="scrollable"
        scrollButtons="auto"
      >
        {formSettings.map((setting, index) => (
          <Tab key={index} label={setting.label} classes={{ selected: classes.selectedTab }}   />
        ))}
      </Tabs>

    </div>
  );
};

export default FormTabs;
